module.exports = __webpack_public_path__ + "img/zd-new-2.81f8e32c.svg";